
import React from 'react';
import $ from 'jquery';
import ProductService from '../services/product';
import ProductSituationDetails from '../products/productSituationDetails';
import Utility from '../utilities/utility';
import AuthorizationCheck from '../auth/authorizationCheck';
import { Modal } from 'react-bootstrap';
import CountryService from '../services/country';


class ProductSituation extends React.Component {

    constructor(props) {
        super(props);

        this.countryService = new CountryService();

        this.state = {
            orderProductSituation: [],
            shipmentProductSituation: [],
            product: [],
            products: [],
            loaded: false,
            currentUserRole: '',
            situationDetails: false,
            countries: [],
            customer: []
        }
    }

    componentDidMount(){

        this.countryList();
     
    }

    

    findProducts = async () => {

        let name = $('#name').val();
        let model = $('#model').val();
        let brand = $('#brand').val();
        let color = $('#color').val();
        let size = $('#size').val();
        let countryId = $('#countryId').val();

        try {

            const response = await ProductService.orderProductList(name, model, brand, size, color, countryId);



            this.setState({

                products: await response.json()
            });



        } catch (error) {
            console.log(error);
        }

    }

    setRole = (role) => {

        this.setState({ currentUserRole: role });
    }

    productSituation = async (productId) => {

        let countryId = $('#countryId').val();

        try {

           
            const response = await ProductService.productSituation(productId, countryId);

            if (response.ok) {

                const situationList = await response.json();



                this.setState({
                    loaded: true,
                    product: situationList.product,
                    orderProductSituation: situationList.orderProductSituations,
                    shipmentProductSituation: situationList.shipmentProductSituations
                });
            }else{

                this.setState({
                    loaded: false,
                    
                });
            }


        } catch (error) {
            this.setState({
                loaded: false,
                
            });
        }

    }


    showSituationDetails = (productId) =>{

        this.productSituation(productId);

        this.setState({situationDetails: true})
    }

    hideSituationDetails = () =>{

        this.setState({situationDetails: false})
    }

    countryList = async() => {

        const res = await this.countryService.fetchCountries();

        this.setState({
            countries : await res.json()
        });
    }


    render() {


        const products = this.state.products;

        const countries = this.state.countries;
        
        
        let countrySelection = '';

      

        if (this.state.currentUserRole == 'MANAGER' || this.state.currentUserRole == 'SUPER-ADMIN') {


            countrySelection = <div className="row">
                <div className="col-md-12">
                    <div className="form-group">
                        <label className="label">Choisi le Pays</label>
                        <select className="form-control" id="countryId" onChange={this.findProducts} >
                            <option></option>
                            {countries.length > 0 && countries.map(country =>

                                <option value={country.countryId}>{country.name}</option>
                            )}
                        </select>
                    </div>
                </div>
            </div>
        }


        return (
            <div className="container situation-wrapper mt-4">


                <AuthorizationCheck accessLevel='USER' userRole={this.setRole} />

                <h2 className="mb-3 text-center">Produit Situation</h2>


                <div className="form-wrapper">

                { countrySelection }
                    <div className="row">
                        <div className="col">


                            <div className="form-group">
                                <input className="form-control" id="name" placeholder="Nom" />
                            </div>
                        </div>
                        <div className="col">
                            <div className="form-group">
                                <input className="form-control" id="model" placeholder="Model" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">

                            <div className="form-group">
                                <input className="form-control" id="brand" placeholder="Marque" />
                            </div>
                        </div>
                        <div className="col">
                            <div className="form-group">
                                <input className="form-control" id="size" placeholder="Numero" />
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <button className="btn btn-primary" onClick={this.findProducts}>Rechercher</button>
                    </div>


                </div>


                <div className='product-wrapper'>

                {products.length ==  0 ? <h2 className='mt-4'>Produits non trouvable</h2>: ''} 

                    {products.length > 0 && products.map(product =>

                        <div className="card card-default mt-2" key={product.id}>

                            <div className="card-body">
                                <div className="row">
                                    <div className="col">{product.name}</div>

                                    <div className="col">{product.model}</div>

                                    <div className="col">{product.brand}</div>
                                    <div className="col">{product.color}</div>
                                    <div className="col">{product.size}</div>
                                    <div className="col">
                                        <button className="btn btn-primary" onClick={()=>this.showSituationDetails(product.id)}>Produit Situation</button>
                                    </div>

                                </div>
                            </div>

                        </div>
                    )}


                </div>

                <Modal show={this.state.situationDetails} size="lg">
                    <Modal.Header closeButton onHide={this.hideSituationDetails}>Produit Situation Details </Modal.Header>
                    <Modal.Body>

                    {
                    <ProductSituationDetails product={this.state.product}
                        orderProductSituation={this.state.orderProductSituation}
                        shipmentProductSituation={this.state.shipmentProductSituation}
                        loaded={this.state.loaded} userRole={this.state.currentUserRole} />
                }

                    </Modal.Body>

                </Modal>

                




            </div>
        )
    }



}

export default ProductSituation;